import React, { useState, useEffect } from "react";
import "./DRMPlanOne.css";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import MyDatePicker from "../Common/DatePicker";
import ModalPopup from "../Common/ModalPopup";
import CommonSnackbar from "../Common/CommonSnackbar";
import { format } from "date-fns";
import { FaThumbsUp } from "react-icons/fa";
import styles from "../MarketVisitReport/MarketVisitReport.module.css";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Box } from "@mui/material";
import { FiArrowRight } from "react-icons/fi";
import { useSelector } from "react-redux";
import { DRMPlanOneAPI } from "../../services/DRM/DRMPlanOneAPI";
import { UpdateMeeting } from "../../services/DRM/UpdateMeeting";
import { Loader } from "../../features/shared";
import { getUniqueListBy } from "../Common/Function";
import _ from "lodash";
import { getWssApi } from "../../services/MarketWorking/MyTeam/getWssApi";
import { SPECASubmit } from "../../services/DRM/SPECASubmit";
import { MdDeleteOutline, MdOutlineAttachment } from "react-icons/md";
import { getTerritory } from "../../services/MarketWorking/MyTeam/getTerritory";
import { getDealerCityDRMApi } from "../../services/DRM/getDealerCityDRMApi";
import { getTown } from "../../services/DRM/getTown";
import { getTownByCodeApi } from "../../services/DRM/getTownApi";
import { getEmployeeIdApi } from "../../services/DRM/getEmployeeIdApi";
import { getDealerRelationshipMeetApi } from "../../services/DRM/getDealerRelationshipMeetApi";
import { getBudgetMaxCost } from "../../services/BudgetManagement/getBudgetMaxCost ";
import { getSubdivisionBySalesGroupApi } from "../../services/DRM/getSubdivisionApi";
import * as XLSX from "xlsx";
import { TEMPLATE_NAMES } from "../../config/apiConstants";
import { getTemplateUrlApi } from "../../services/templates/getTemplateUrlApi";

const territoryAutoCompletePlaceHolder = {
  attributes: null,
  Id: null,
  SH2_Name__c: null,
  SH2_Code__c: null,
  Name: null,
  SH3_Code__c: null,
};
const wsscodeAutoCompletePlaceHolder = {
  attributes: null,
  CustomerName__c: null,
  Customer_Code__c: null,
  Id: null,
  Monthly_Tour_Plan_CheckIn__c: null,
  TSI_Territory_Code__c: null,
  Town__c: null,
  WSS_latitude__c: null,
  WSS_longitude__c: null,
};
const townAutocompletePlaceHolder = {
  attributes: null,
  Id: null,
  TownCode__c: null,
  Town__c: null,
};

const dealerAutocompletePlaceHolder = {
  attributes: null,
  Id: null,
  CityCode_c: null,
  DealerCity__c: null,
};

const subdivisionAutocompletePlaceHolder = {
  id: null,
  sales_group_code: null,
  subdivision_id: null,
  subdivision_name: null,
};

/**
 * MUI Autocomplete renders BLANK when the controlled `value` is not present in
 * `options`. A saved DRM can hold a picklist value that isn't in the freshly
 * fetched options (picklist still loading, different sales group, or trimmed
 * punctuation/whitespace). Inject the saved value so it always displays.
 */
const withSelectedOption = (options, value) => {
  const list = Array.isArray(options) ? options : [];
  return value && !list.includes(value) ? [value, ...list] : list;
};

const options = ["Option 1", "Option 2", "Option 3", "Option 4", "Option 5x"];

const DRMPlanOne = ({
  formData,
  failedOpen,
  setFailesOpen,
  snackerror,
  setSnackError,
  setTownName,
  showReason,
  DisableSubmitDRM,
  setDisableSubmitDRM,
  setShowReason,
  feedbackcount,
  attendancecount,
  statusCompleted,
  disableTown,
  townlist,
  setDisableUpdate,
  disableUpdate,
  setSpecaObj,
  specaObj,
  startExecution,
  setStartExecution,
  setUnableUpdate,
  setMeetingDetails,
  setDisableActualDate,
  setTabValue,
  QRvisible,
  setExecutionDisable,
  setDisable,
  territoryOption,
  setLoading,
  disableactualdate,
  initialFormData,
  mindate,
  setFormData,
  setBlockTab,
  meetingdetails,
  executiondisable,
  disable,
  unableupdate,
  setErrors,
  errors,
  setTriggerMeetings,
  loading,
  excelFileName,
  setExcelFileName,
  uploadedFile,
  setUploadedFile,
}) => {
  const userEmailid = useSelector(
    (state) => state?.userDetails?.details?.Email,
  );
  const clusterCode = useSelector(
    (state) => state?.userDetails?.details?.SH_Code__c,
  );
  const zone = useSelector((state) => state?.userDetails?.details?.Division);
  const userType = useSelector((state) =>
    state?.userType?.type != "Other"
      ? state?.userType?.type
      : state?.userDetails?.details?.Title,
  );
  const salesGroupCode = useSelector(
    (state) => state?.userDetails?.details?.Sales_Group_Code__c,
  );
  const accessToken = useSelector((state) => state?.tokens?.accessToken);
  const [territoryPickList, setTerritoryPickList] = useState();
  const [isSubmitModalOpen, setIsSubmitModalOpen] = useState(false);
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [specamodal, setSpecaModal] = useState(false);
  const [wsspicklist, setWssPicklist] = useState();
  const [townPicklist, setTownPicklist] = useState();
  const [testPicklist, setTestPicklist] = useState(
    "TANZEEM : 1045750,PARAS REXINE HOUSE : 1047358,PEARLS WALL PAPER CO : 1023558",
  );
  const tname = useSelector((state) => state?.territory?.territoryDetails);
  const [wssOption, setWssOption] = useState([]);
  const [townNameOption, setTownNameOption] = useState([]);
  const [territoryDropOption, setTerritoryDropOption] = useState([]);
  const [wsscode, setWssCode] = useState([]);
  const [error, setError] = useState("");
  const [isWssData, setIsWssData] = useState("Loading");
  const [isTerritoryData, setIsTerritoryData] = useState("Loading");
  // const [failedOpen, setFailesOpen] = useState(false);
  const [selectedWss, setSelectedWss] = useState({});
  // const [snackerror, setSnackError] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);

  const [fileValidation, setFileValidation] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [file, setFile] = useState([]);
  const [selectedTown, setSelectedTown] = useState(townAutocompletePlaceHolder);
  const [selectedTerritory, setSelectedTerritory] = useState(
    territoryAutoCompletePlaceHolder,
  );
  const [value, setValue] = useState(null);

  // Town Name (PostgreSQL)
  const [townNameOptions, setTownNameOptions] = useState([]);
  const [isTownNameData, setIsTownNameData] = useState("Loading");

  // dealer City (Salesforce)
  const [dealerCityOptions, setDealerCityOptions] = useState();
  const [isDealerCityData, setIsDealerCityData] = useState("Loading");
  const [selectedDealerCity, setSelectedDealerCity] = useState(
    dealerAutocompletePlaceHolder,
  );
  const [employeeId, setEmployeeId] = useState("");
  const [dealerRelationshipMeeet, setDealerRelationshipMeeet] = useState({});
  const [maxCost, setMaxCost] = useState(0);
  const [budgetData, setBudgetData] = useState([]);
  const [excelValidation, setExcelValidation] = useState("");
  const [drmTemplateUrl, setDrmTemplateUrl] = useState("");

  useEffect(() => {
    getTemplateUrlApi(TEMPLATE_NAMES.DRM_DEALER_LIST)
      .then((res) => {
        if (res?.data?.success) setDrmTemplateUrl(res.data.url);
      })
      .catch(() => {});
  }, []);

  // subdivision
  const [subdivisionOptions, setSubdivisionOptions] = useState([]);
  const [isSubdivisionData, setIsSubdivisionData] = useState("Loading");
  const [selectedSubdivision, setSelectedSubdivision] = useState(
    subdivisionAutocompletePlaceHolder,
  );
  // const [excelFileName, setExcelFileName] = useState("");

  // const [uploadedFile, setUploadedFile] = useState({
  //   fileName: "",
  //   base64: "",
  //   fileExtension: "",
  //   totalDealers: 0,
  //   totalParticipants: 0,
  //   dealerCode: ""
  // });

  // console.log("USerType===>", userType)

  useEffect(() => {
    const event = {
      name: "salesGroupUserType",
      value: selectedOptions
        .map((item) => `${item.CustomerName__c} : ${item?.Customer_Code__c}`)
        .join(","),
    };
  }, [selectedOptions, formData, file]);

  useEffect(() => {
    (async () => {
      try {
        const result = await getEmployeeIdApi(userEmailid);
        if (!_.isEmpty(result?.data?.records[0])) {
          setEmployeeId(result?.data?.records[0].Employee_Code__c);
        }
      } catch (error) {
        setEmployeeId("");
        setLoading(false);
      }
    })();
  }, [userEmailid]);

  const handleFileChange = async (event) => {
    setFileValidation("");
    setFile([]);
    const files = event.target.files;
    const filesArray = Array.from(files);

    let invalidFiles = [];
    filesArray.forEach((file) => {
      if (file.size > 10 * 1024 * 1024) {
        invalidFiles.push(file.name);
      }
    });

    if (invalidFiles?.length > 0) {
      setFileValidation(`Files exceed 10 MB: ${invalidFiles.join(", ")}`);
    } else if (filesArray?.length > 5) {
      setFileValidation("Please select Maximum 5 files");
    } else {
      setSelectedFiles(filesArray);
      filesArray?.map(async (file, index) => {
        const fileExtension = file?.name?.split(".")[1];
        const base64 = await convertBase64(file);
        setFile((fs) => [
          ...fs,
          {
            ImageName: `${meetingdetails?.Id}_${index + 1}.${fileExtension}`,
            ImageContent: base64.replace("data:", "").replace(/^.+,/, ""),
          },
        ]);
      });
    }
  };
  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  useEffect(() => {
    const uniq = getUniqueListBy(territoryOption, "SH2_Code__c");

    setFormData((prev) => ({
      ...prev,

      SG: (meetingdetails?.SG__c ?? meetingdetails?.SG) || "",
      Zone: (meetingdetails?.Zone__c ?? meetingdetails?.Zone) || "",
      ClusterName:
        (meetingdetails?.Cluster_Name__c ?? meetingdetails?.ClusterName) || "",
      TSITerritoryName:
        (meetingdetails?.TSI_Territory_Name__c ??
          meetingdetails?.TSITerritoryName) ||
        "",
      TownName:
        (meetingdetails?.Town_name__c ?? meetingdetails?.TownName) || "",
      DealerCity:
        (meetingdetails?.Dealer_City__c ?? meetingdetails?.DealerCity) || "",
      SubdivisionId:
        (meetingdetails?.Subdivision_Id__c ?? meetingdetails?.SubdivisionId) || "",
      SubdivisionName:
        (meetingdetails?.Subdivision_Name__c ?? meetingdetails?.SubdivisionName) || "",
      CustomerName:
        (meetingdetails?.Customer_Name__c ?? meetingdetails?.CustomerName) ||
        "",
      Population:
        meetingdetails?.Population__c ?? meetingdetails?.Population ?? null,

      ObjectiveOfMeet:
        (meetingdetails?.Objective_of_meet__c ??
          meetingdetails?.ObjectiveOfMeet) ||
        "",
      TypeOfDRM:
        (meetingdetails?.Type_of_DRM__c ?? meetingdetails?.TypeOfDRM) || "",
      TownSelectionCriteria:
        (meetingdetails?.Town_Selection_criteria__c ??
          meetingdetails?.TownSelectionCriteria) ||
        "",
      DealerSelectionCriteria:
        (meetingdetails?.Dealer_Selection_Criteria__c ??
          meetingdetails?.DealerSelectionCriteria) ||
        "",
      IfCategorySpecificDealersThenWhichCategory:
        (meetingdetails?.If_Category_Specific_dealers_then_which__c ??
          meetingdetails?.IfCategorySpecificDealersThenWhichCategory) ||
        "",

      NoOfPCCdealersInTown:
        (meetingdetails?.No_of_PCC_dealers_in_town__c ??
          meetingdetails?.NoOfPCCdealersInTown) ||
        null,
      EstimatedNoOfDealersToParticipate:
        (meetingdetails?.Estimated_no_of_Dealers_to_Participate__c ??
          meetingdetails?.EstimatedNoOfDealersToParticipate) ||
        null,
      TotalHeadCountDealer:
        (meetingdetails?.Total_Head_Count_Dealer__c ??
          meetingdetails?.TotalHeadCountDealer) ||
        "",
      TotalHeadCountEmployee:
        (meetingdetails?.Total_Head_Count_Employee__c ??
          meetingdetails?.TotalHeadCountEmployee) ||
        "",
      TotalCost:
        (meetingdetails?.Total_Cost__c ?? meetingdetails?.TotalCost) || "",
      CostPerHead:
        (meetingdetails?.Cost_Per_Head__c ?? meetingdetails?.CostPerHead) || "",
      ReasonForCost:
        (meetingdetails?.ReasonForCost__c ?? meetingdetails?.ReasonForCost) ||
        "",

      CurrentMonthlyAverageSalesOfTown:
        (meetingdetails?.Current_monthly_average_sales_of_Town__c ??
          meetingdetails?.CurrentMonthlyAverageSalesOfTown) ||
        null,
      PostDRMMonthlyAverageSalePlannedForTheTown:
        (meetingdetails?.Post_DRM_monthly_average_sale_planned__c ??
          meetingdetails?.PostDRMMonthlyAverageSalePlannedForTheTown) ||
        null,

      TentativeDateOfTheMeet: meetingdetails?.Tentative_date_of_the_meet__c
        ? dayjs(meetingdetails.Tentative_date_of_the_meet__c)
        : meetingdetails?.TentativeDateOfTheMeet
          ? dayjs(meetingdetails.TentativeDateOfTheMeet)
          : null,

      ActualDateOfTheMeet: meetingdetails?.Actual_Date_of_the_Meet__c
        ? dayjs(meetingdetails.Actual_Date_of_the_Meet__c)
        : meetingdetails?.ActualDateOfTheMeet
          ? dayjs(meetingdetails.ActualDateOfTheMeet)
          : null,

      ActualNoOfEmployeesParticipated:
        meetingdetails?.ActuaNoOfEmployeesParticipated ??
        meetingdetails?.ActualNoOfEmployeesParticipated ??
        null,
      ActualNoOfDealersParticipated:
        meetingdetails?.ActuaNoOfDealersParticipated ??
        meetingdetails?.ActualNoOfDealersParticipated ??
        null,
      ActualCost:
        meetingdetails?.ActualCost ?? meetingdetails?.ActualCost ?? null,

      BMRemark: (meetingdetails?.BMremark ?? meetingdetails?.BMRemark) || null,
      DeviationComments:
        (meetingdetails?.Deviation_Comments__c ??
          meetingdetails?.DeviationComments) ||
        null,
      PlannedDRMType:
        (meetingdetails?.Planned_DRM_Type__c ??
          meetingdetails?.PlannedDRMType) ||
        null,

      ExcelFileName:
        (meetingdetails?.ExcelFileName ?? meetingdetails?.ExcelFileName) || null,
      ExcelFileExtension:
        (meetingdetails?.ExcelFileExtension ??
          meetingdetails?.ExcelFileExtension) ||
        null,
      ExcelBase64:
        (meetingdetails?.ExcelBase64 ?? meetingdetails?.ExcelBase64) || null,
    }));
  }, [meetingdetails]);
  //------------------------------ Check SG for prefix -------------------------------//

  const salesGroupMap = {
    105: "FV",
    301: "MNT",
    401: "CC",
    406: "ROFF",
    901: "EI",
    902: "EI",
  };

  const generateSharedId = (salesGroupCode, id) => {
    const prefix = salesGroupMap[salesGroupCode] || "UNKNOWN"; // Default if not found
    return `${prefix}${id}`;
  };

  //-----------------------------------------------------------------------------------//
  useEffect(() => {
    (async () => {
      try {
        const result = await getDealerRelationshipMeetApi(
          accessToken,
          salesGroupCode,
        );
        setDealerRelationshipMeeet(result?.data);
      } catch (error) {
        setDealerRelationshipMeeet({});
        setLoading(false);
      }
    })();
  }, [salesGroupCode]);

  useEffect(() => {
    setSpecaObj((prevState) => ({
      ...prevState,
      Division: zone,
      SalesGroup: formData?.SG,
      HierarchyCode: formData?.TSITerritoryName.split(":").pop().trim(),
      VerticalName: formData?.SG,
      MeetingDate: formData?.ActualDateOfTheMeet,
      MeetingType: "DRM (MANAGED BY FIELD)",
      MeetingCode: generateSharedId(formData?.SG, meetingdetails?.Id),
      CityName: formData?.TownName.split(":")[0].trim(),
      TownCode: "UGJ00006", // 8 characters
      PerHeadCost: formData?.CostPerHead,
      InviteeCount:
        Number(`${formData?.TotalHeadCountDealer}`) +
        Number(`${formData?.TotalHeadCountEmployee}`), /// validation 0..00
      AttendeeCount:
        Number(`${formData?.ActualNoOfDealersParticipated}`) +
        Number(`${formData?.ActualNoOfEmployeesParticipated}`), /// validation 0..00
      TotalAmount: formData?.ActualCost,
      AttendeesPhoto: "()",
      Billno: "0",
      ITrakToTEMFlag: "Y",
      ITrakToTEMDate: "2024-01-02 00:00:00",
      Attendee_KYCRecieved: 0,
      Attendee_KYCNotRecieved: 0,
      Attendee_Stakeholders: 0,
      Attendee_Helper: 0,
      Attendee_Repeat: "0",
      MeetingFormat: "Physical Meet",
      ADV_AND_PROMO: "",
      EMPLOYEECODE: employeeId,
    }));
  }, [formData]);
  //// snackbar close //////////
  const handleOnClose = (reason) => {
    if (reason === "clickaway") {
      return;
    }
    setFailesOpen(false);
  };

  //// Set Territory and WSS for current meeting
  useEffect(() => {
    const territoryid = tname.filter(
      (territory) =>
        territory?.SH2_Name__c === meetingdetails?.TSI_Territory_Name__c,
    );

    // setTerritoryPickList(territoryid[0] ? `${territoryid[0].SH2_Name__c} : ${territoryid[0].SH2_Code__c}` : "")
    setTerritoryPickList(
      (meetingdetails?.TSI_Territory_Name__c ??
        meetingdetails?.TSITerritoryName) ||
        "",
    );

    // setWssPicklist(meetingdetails?.Customer_Code__c ? `${meetingdetails?.Customer_Name__c} : ${meetingdetails?.Customer_Code__c}` : "")
    setWssPicklist(
      (meetingdetails?.Customer_Name__c ?? meetingdetails?.CustomerName) || "",
    );
    setTownPicklist(
      (meetingdetails?.Town_name__c ?? meetingdetails?.TownName) || "",
    );
  }, [meetingdetails]);

  // Fetch city_type_id from PostgreSQL when town is selected
  useEffect(() => {
    const fetchCityTypeId = async () => {
      if (selectedTown?.TownCode__c) {
        const res = await getTownByCodeApi(selectedTown.TownCode__c);
        if (res?.success && res?.data?.city_type_id) {
          // Fetch budget data using city_type_id
          const data = await getBudgetMaxCost(res.data.city_type_id);
          setBudgetData(data || []);
        }
      }
    };

    fetchCityTypeId();
  }, [selectedTown]);

  // Update maxCost when TypeOfDRM changes
  useEffect(() => {
    if (formData.TypeOfDRM && budgetData.length > 0) {
      const matchingBudget = budgetData.find(
        (item) => item.Type_of_DRM__c === formData.TypeOfDRM
      );
      setMaxCost(matchingBudget?.Max_Cost__c || 0);
    }
  }, [formData.TypeOfDRM, budgetData]);

  // Calculate CostPerHead whenever TotalCost or TotalHeadCount changes
  // useEffect(() => {

  //   if (formData.TotalCost && formData.TotalHeadCount) {
  //     const costPerHead = (formData.TotalCost / formData.TotalHeadCount).toFixed(2);
  //     setFormData({ ...formData, CostPerHead: costPerHead });
  //   } else {
  //     setFormData({ ...formData, CostPerHead: "" });
  //   }
  // }, [formData.TotalCost, formData.TotalHeadCount]);

  // Calculate TotalCost whenever CostPerHead or TotalHeadCount changes
  useEffect(() => {
    if (
      formData.CostPerHead &&
      formData.TotalHeadCountDealer &&
      formData.TotalHeadCountEmployee
    ) {
      const TotalCost =
        (Number(formData.TotalHeadCountDealer) +
          Number(formData.TotalHeadCountEmployee)) *
        Number(formData.CostPerHead);
      setFormData({ ...formData, TotalCost: TotalCost });
    } else {
      setFormData({ ...formData, TotalCost: "" });
    }
  }, [
    formData.CostPerHead,
    formData.TotalHeadCountDealer,
    formData.TotalHeadCountEmployee,
  ]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (
      (name === "ActualNoOfDealersParticipated" ||
        name === "ActualNoOfEmployeesParticipated" ||
        name === "ActualCost") &&
      value !== ""
    ) {
      setFormData({ ...formData, [name]: Number(value) });
    } else if (name === "Population" && value === "") {
      setFormData({ ...formData, [name]: null });
    } else {
      setFormData({ ...formData, [name]: value });
    }

    if (name === "Population" && value > 50) {
      setErrors({
        ...errors,
        Population: "Total Population can not be greater than 50 lacs",
      });
    } else if (
      (name === "ActualNoOfDealersParticipated" ||
        name === "NoOfPCCdealersInTown" ||
        name === "EstimatedNoOfDealersToParticipate" ||
        name === "TotalHeadCountDealer" ||
        name === "TotalHeadCountEmployee" ||
        name === "CostPerHead" ||
        name === "CurrentMonthlyAverageSalesOfTown" ||
        name === "PostDRMMonthlyAverageSalePlannedForTheTown") &&
      !Number.isInteger(Number(value))
    ) {
      setErrors({ ...errors, [name]: "Can not enter decimal value" });
    } else {
      setErrors({ ...errors, [name]: "" });
    }

    // ⭐⭐ UPDATED MAX COST CHECK — REAL-TIME ⭐⭐
    if (name === "CostPerHead") {
      const cost = Number(value);

      if (maxCost != null && maxCost !== undefined && maxCost > 0 && cost > maxCost) {
        setErrors({
          ...errors,
          CostPerHead: `Entered cost exceeds maximum allowed (${maxCost}). Please provide reason for deviation.`,
        });

        setShowReason(true);
      } else {
        setErrors({
          ...errors,
          CostPerHead: "",
        });

        setShowReason(false);
      }
    }
  };

  const handleAutocompleteChange = (name, newValue) => {
    if (name == "TSITerritoryName") {
      setFormData({
        ...formData,
        [name]: `${newValue?.TSI_Territory_Name__c} : ${newValue?.TSI_Territory_Code__c}`,
        CustomerName: "",
      });
      setSelectedWss({});
      setSelectedOptions([]);
      setWssPicklist(false);
    } else if (name == "TownName") {
      setFormData({
        ...formData,
        [name]: `${newValue?.Town__c} : ${newValue?.TownCode__c}`,
        TSITerritoryName: "",
      });
      setTerritoryPickList("");
      setSelectedTerritory("");
    } else if (name == "DealerCity") {
      setFormData({
        ...formData,
        [name]: `${newValue?.DealerCity__c} : ${newValue?.CityCode__c}`,
      });
    } else if (name == "CustomerName") {
      setFormData({
        ...formData,
        [name]: newValue
          .map((item) => `${item.CustomerName__c} : ${item?.Customer_Code__c}`)
          .join(","),
      });
      // "TownName": newValue.Town__c
      // setFormData({ ...formData, [name]: newValue.Customer_Code__c,"CustomerName" : newValue.CustomerName__c,"TownName": newValue.Town__c });
    } else {
      setFormData({ ...formData, [name]: newValue });
    }
  };

  const handleDateChange = (name, newValue) => {
    setFormData({
      ...formData,
      [name]: newValue,
    });
  };

  const validateExecution = () => {
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      if (!formData[key] && formData[key] !== 0) {
        newErrors[key] = "This field is required";
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const validateForm = () => {
    const newErrors = {};

    Object.keys(formData).forEach((key) => {
      // Skip validation completely for status fields
      if (key === "ZSMStatus" || key === "TMMStatus" || key === "NSMStatus") {
        return;
      }

      // Optional fields that only matter if startExecution is true
      const optionalFields = [
        "ActualNoOfDealersParticipated",
        "ActualNoOfEmployeesParticipated",
        "BMRemark",
        "ActualCost",
        "Population",
        "DeviationComments", // also skip empty string if optional
        "ReasonForCost", // Not displayed in UI, optional field
        "PlannedDRMType",
        "Zone", // Auto-set for SH3, optional for others
        "NoOfPCCdealersInTown",
        "CurrentMonthlyAverageSalesOfTown",
        "PostDRMMonthlyAverageSalePlannedForTheTown",
        "ExcelBase64",
        "ExcelFileExtension",
        "ExcelFileName",
        "ReasonForCost",
        "IfCategorySpecificDealersThenWhichCategory",
      ];

      if (optionalFields.includes(key)) {
        return; // skip validation
      }

      // Actual Date of the Meet is only required after NSM approves the DRM
      // (the field stays disabled/uneditable until then, so it can't be filled earlier)
      if (key === "ActualDateOfTheMeet" && disableactualdate) {
        return;
      }

      console.log('key', key);


      // Required check: null, undefined, or empty string are invalid
      if (
        formData[key] === null ||
        formData[key] === undefined ||
        formData[key] === ""
      ) {
        newErrors[key] = "This field is required";
      }
    });

    console.log('newErrors', newErrors);
    

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleUpdate = async (e) => {
    // format actual date ////
    const actualDate = formData?.ActualDateOfTheMeet;
    const tentativeDate = formData?.TentativeDateOfTheMeet;
    const currentmeetingid = meetingdetails?.Id;
    const formattedActualDate = actualDate
      ? format(new Date(actualDate), "yyyy-MM-dd")
      : null;
    const formattedTentativeDate = tentativeDate
      ? format(new Date(tentativeDate), "yyyy-MM-dd")
      : null;

    if (validateForm()) {
      try {
        const formDataWithId = {
          ...formData,
          id: meetingdetails?.Id,
          NSMStatus: meetingdetails?.NSM_Status__c ?? meetingdetails?.NSMStatus,
          ZSMStatus: meetingdetails?.ZSM_Status__c ?? meetingdetails?.ZSMStatus,
          TMMStatus: meetingdetails?.TMM_Status__c ?? meetingdetails?.TMMStatus,
          NSMFeedback:
            meetingdetails?.NSM_Feedback__c ?? meetingdetails?.NSMFeedback,
          ActualDateOfTheMeet: formattedActualDate,
          TentativeDateOfTheMeet: formattedTentativeDate,
          ReasonForCost: formData?.ReasonForCost,
          PlannedDRMType: formData?.PlannedDRMType,
        };
        setLoading(true);
        const response = await UpdateMeeting({ formDataWithId });

        if (response?.success) {
          setDisableUpdate(true);
          // Re-fetch through the same API the page loads with (DRMPlanOneAPI),
          // so meetingdetails keeps the consistent non-__c shape that includes
          // all approval statuses (ZSM/TMM/NSM). getMeetingDetails (SOQL) does
          // not even select TMM_Status__c, which would drop it on a re-update.
          const refetch = await DRMPlanOneAPI({
            method: "get",
            meetingId: currentmeetingid,
          });
          if (refetch?.success) {
            const refetched = JSON.parse(refetch.data)?.DRM?.[0];
            const nsm = refetched?.NSM_Status__c ?? refetched?.NSMStatus;
            if (nsm === "Approved") {
              setMeetingDetails({ ...refetched, Id: currentmeetingid });
              setDisableUpdate(false);
            }
          }
          setIsUpdateModalOpen(true);
          setLoading(false);

          setDisable(true);
        } else {
          setFailesOpen(true);
          setSnackError(response?.msg);
          setLoading(false);
        }
      } catch (error) {
        console.error("Error during API call:", error);
        setSnackError("Something went wrong..");
        setFailesOpen(true);
      }
    }
  };

  ///// creation of new Meeting //////////////
  const handleSubmit = async (e) => {
    e.preventDefault();
    const tentativeDate = formData?.TentativeDateOfTheMeet;
    const actualDate = formData?.ActualDateOfTheMeet;
    const formattedTentativeDate = tentativeDate
      ? format(new Date(tentativeDate), "yyyy-MM-dd")
      : null;
    const formattedActualDate = actualDate
      ? format(new Date(actualDate), "yyyy-MM-dd")
      : null;
    const newFormData = {
      ...formData,
      TentativeDateOfTheMeet: formattedTentativeDate,
      ActualDateOfTheMeet: formattedActualDate,

      ExcelFileName: uploadedFile.fileName || null,
      ExcelBase64: uploadedFile.base64 || null,
      ExcelFileExtension: uploadedFile.fileExtension || null,
      ReasonForCost: formData?.ReasonForCost,
      PlannedDRMType:
        (userType === "SH3" || userType === "SH4")
          ? "Relationship based DRM"
          : formData?.PlannedDRMType,
      isTMMCreated: userType === "TMM" ? "true" : "false",
      isZSMCreated: (userType === "SH5" || userType === "SH6") ? "true" : "false",
      isBMCreated: userType === "SH3" ? "true" : "false",
      ...(userType === "TMM" && {
        ZSMStatus: null,
        TMMStatus: null,
        NSMStatus: "Pending",
      }),
    };

    if (validateForm()) {
      try {
        setLoading(true);
        const response = await DRMPlanOneAPI({ newFormData });
        if (response?.success) {
          setTriggerMeetings(true);
          setFormData(initialFormData);
          setIsSubmitModalOpen(true);
          setLoading(false);
          setSelectedWss({});
        } else {
          setSnackError(response?.msg);
          setFailesOpen(true);
          setLoading(false);
        }
      } catch (error) {
        console.error("Error during API call:", error);
        setSnackError("Something went wrong..");
        setFailesOpen(true);
      }
    }
  };
  ////// Validate Attched Image ///
  const validateFile = () => {
    if (!file || file.length === 0) {
      setFileValidation("Please Attach Your Photo");
      return false; // Indicating validation failed
    } else {
      return true; // Indicating validation passed
    }
  };
  ////// handle final submission of DRM Form //////////////
  const handleSpecaSubmit = async (e) => {
    //// format current time yyyy-MM-dd HH:mm:ss in this format ////
    const convertDateToSpecaFormat = (originalDate) => {
      const utcYear = originalDate.getUTCFullYear();
      const utcMonth = originalDate.getUTCMonth() + 1; // Months are 0-indexed, so add 1
      const utcDay = originalDate.getUTCDate();
      const utcHours = originalDate.getUTCHours();
      const utcMinutes = originalDate.getUTCMinutes();

      // Format the date into "YYYY-MM-DD HH:mm:ss.SSSZ"
      const formattedDate = `${utcYear}-${pad(utcMonth)}-${pad(utcDay)} ${pad(utcHours)}:${pad(utcMinutes)}:00.000Z`;

      // Function to pad single digit numbers with leading zeros
      function pad(number) {
        if (number < 10) {
          return "0" + number;
        }
        return number;
      }
      return formattedDate;
    };
    /// convert current local time to utc ///
    const now = new Date();
    const CurrentDate = convertDateToSpecaFormat(now);
    /// convert Actual date of meet to utc ///
    const date = new Date(formData?.ActualDateOfTheMeet);
    const MeetingDate = convertDateToSpecaFormat(date);

    //// trim the town code from townname string ///
    const originalString = formData?.TownName;
    const townCode = originalString.split(":")[1].trim();

    ///// update current speca object with formated values ///
    const NextSpecaObj = {
      ...specaObj,
      MeetingDate: MeetingDate,
      ITrakToTEMDate: CurrentDate,
      TownCode: townCode,
    };

    if (validateForm() && validateFile()) {
      try {
        setLoading(true);
        // const response = await SPECASubmit({ NextSpecaObj });
        if (true) {
          const tentativeDateRaw = formData?.TentativeDateOfTheMeet;
          const actualDateRaw = formData?.ActualDateOfTheMeet;
          const formattedTentativeDate = tentativeDateRaw
            ? format(new Date(tentativeDateRaw), "yyyy-MM-dd")
            : null;
          const formattedActualDate = actualDateRaw
            ? format(new Date(actualDateRaw), "yyyy-MM-dd")
            : null;

          const formDataWithId = {
            ...formData,
            id: meetingdetails?.Id,
            TentativeDateOfTheMeet: formattedTentativeDate,
            ActualDateOfTheMeet: formattedActualDate,
            NSMStatus: "Completed",
            ZSMStatus: "Completed",
            Images: file,
          };
          const updateresponse = await UpdateMeeting({ formDataWithId });
          if (updateresponse?.success == true) {
            setDisableSubmitDRM(true);
            setLoading(false);
            setSpecaModal(true);
          } else {
            setFailesOpen(true);
            setSnackError(
              "something went wrong.. try again after some time or contact your admin for further assistance..",
            );
            setLoading(false);
          }
        } else {
          // setSnackError(response?.msg)
          setFailesOpen(true);
          setSnackError(
            "something went wrong.. try again after some time or contact your admin for further assistance..",
          );
          setLoading(false);
        }
      } catch (error) {
        console.error("Error during API call:", error);
        setFailesOpen(true);
        setSnackError("something went wrong..");
        setLoading(false);
      }
    }
  };
  ///// On click QR Code start meeting ///
  const startMeeting = () => {
    // Removed date validation - QR code can be activated anytime after NSM approval
    setBlockTab(true);
    setExecutionDisable(true);
    setUnableUpdate(true);
    setStartExecution(true);
    setTabValue("2");
    setDisableActualDate(true);
  };
  useEffect(() => {
    setIsTerritoryData("Loading");
    {
      (async () => {
        let TownCode__c = selectedTown?.TownCode__c;
        const response = await getTerritory({ TownCode__c, clusterCode });

        if (response?.success) {
          if (response?.data?.totalSize === 0) {
            setIsTerritoryData("false");
          } else {
            setIsTerritoryData("true");
            // setWssOption(response?.data?.records);
            // setTownNameOption(response?.data?.records)
            setTerritoryDropOption(response?.data?.records);

            // setSelectedTerritory("");
          }
        } else {
          setSnackError(response?.msg);
          setFailesOpen(true);
        }
      })();
    }
  }, [selectedTown]);

  // Wss Name API call
  useEffect(() => {
    setIsWssData("Loading");
    {
      (async () => {
        let SH2_Code__c = selectedTerritory?.TSI_Territory_Code__c;
        const response = await getWssApi({ SH2_Code__c });
        if (response?.success) {
          if (response?.data?.totalSize === 0) {
            setIsWssData("false");
          } else {
            setIsWssData("true");
            setWssOption(response?.data?.records);
            setTownNameOption(response?.data?.records);

            // setSelectedTerritory("");
          }
        } else {
          setSnackError(response?.msg);
          setFailesOpen(true);
        }
      })();
    }
  }, [selectedTerritory]);

  const handleExcelUpload = async (event) => {
    setExcelValidation("");
    const file = event.target.files[0];
    if (!file) return;

    // Set file name for UI
    setExcelFileName(file.name);

    // Validate size
    if (file.size > 5 * 1024 * 1024) {
      setExcelValidation("File exceeds 5 MB limit.");
      return;
    }

    try {
      // Read Excel
      const buffer = await file.arrayBuffer();
      const workbook = XLSX.read(buffer, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const sheet = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);

      // Total Dealers
      const totalDealers = sheet.length;

      // Total Participants
      const totalParticipants = sheet.reduce((acc, row) => {
        return acc + Number(row.Participants || 0);
      }, 0);

      // Convert to Base64
      const base64 = await convertBase64(file);

      // File Extension
      const fileExtension = file.name.split(".").pop();

      // -------------------------------
      // Save the Uploaded File Payload
      // -------------------------------
      setUploadedFile({
        fileName: file.name,
        base64: base64.replace("data:", "").replace(/^.+,/, ""),
        fileExtension,
        dealerCode: file.name.split("_")[0] || "",
        totalDealers,
        totalParticipants,
      });

      // -------------------------------
      // Update required form fields
      // -------------------------------
      setFormData((prev) => ({
        ...prev,
        EstimatedNoOfDealersToParticipate: totalDealers,
        TotalHeadCountDealer: totalDealers,
        TotalHeadCountEmployee: totalParticipants,
      }));
    } catch (err) {
      console.error("Error reading Excel file:", err);
      setExcelValidation("Failed to read Excel file. Please try again.");
    }
  };

  const base64ToBlob = (base64, mimeType) => {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: mimeType });
  };

  // ---------------------------------------- Town Name (Salesforce) -------------------------------------------------//

  useEffect(() => {
    if (clusterCode) {
      (async () => {
        setIsTownNameData("Loading");
        const res = await getTown({ cluster: clusterCode });
        if (res?.success) {
          if (res?.data?.records?.length === 0) {
            setIsTownNameData("false");
            setTownNameOptions([]);
          } else {
            setTownNameOptions(res?.data?.records);
            setIsTownNameData("true");
          }
        } else {
          setIsTownNameData("false");
          setTownNameOptions([]);
        }
      })();
    }
  }, [clusterCode]);

  // ---------------------------------------- Dealer City (Salesforce) -------------------------------------------------//

  useEffect(() => {
    if (clusterCode) {
      (async () => {
        setIsDealerCityData("Loading");
        const res = await getDealerCityDRMApi(clusterCode);
        if (res?.success) {
          if (res?.data?.length === 0) {
            setIsDealerCityData("false");
            setDealerCityOptions([]);
          } else {
            setDealerCityOptions(res?.data);
            setIsDealerCityData("true");
          }
        } else {
          setIsDealerCityData("false");
          setDealerCityOptions([]);
        }
      })();
    }
  }, [clusterCode]);

  // ---------------------------------------- Subdivision -------------------------------------------------//

  useEffect(() => {
    if (salesGroupCode) {
      (async () => {
        setIsSubdivisionData("Loading");
        const res = await getSubdivisionBySalesGroupApi(salesGroupCode);
        if (res?.success) {
          if (res?.data?.length === 0) {
            setIsSubdivisionData("false");
            setSubdivisionOptions([]);
          } else {
            setSubdivisionOptions(res?.data);
            setIsSubdivisionData("true");
          }
        } else {
          setIsSubdivisionData("false");
          setSubdivisionOptions([]);
        }
      })();
    }
  }, [salesGroupCode]);

  // Set selected subdivision when options load and formData has SubdivisionId
  useEffect(() => {
    if (subdivisionOptions.length > 0 && formData?.SubdivisionId) {
      const matchingSubdivision = subdivisionOptions.find(
        (option) => option.subdivision_id === formData.SubdivisionId
      );
      if (matchingSubdivision) {
        setSelectedSubdivision(matchingSubdivision);
      }
    }
  }, [subdivisionOptions, formData?.SubdivisionId]);

  // --------------------------------------------------------------------------------------------------------- //

  return (
    <div className="p-0">
      <CommonSnackbar
        open={failedOpen}
        autoHideDuration={7000}
        onClose={handleOnClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        severity={"error"}
        message={snackerror}
      />
      <Loader loading={loading} />
      <div className="drm__Innerbox">
        {statusCompleted && (
          <>
            <div className="DRM_QR">
              <h6 style={{ color: "green" }}>
                Attendance Count: {attendancecount || 0} | Feedback Count: {feedbackcount || 0}
              </h6>
            </div>
          </>
        )}
        {QRvisible && (
          <div className="DRM_QR" onClick={() => startMeeting()}>
            <button className="start_meet">
              <p className="start_meeting_text">Activate QR</p>{" "}
            </button>
          </div>
        )}
        <form onSubmit={handleSubmit}>
          {/* <div className="input_field_outer">
                   <label className= "DRM_Form_label">
                     SG
                   </label>
                   <input
                     className= "DRM_Form_text_input"
                     style={{ paddingLeft: "8px" }}
                     name="SG"
                     value= {formData.SG}
                     onChange= {handleInputChange}
                     disabled= {disable}
                     maxLength={256}
                   />
                   {errors.SG && <p className={styles.MarketVisitReport__validationErrors}>{errors.SG}</p>}
                </div>
                <div  className="input_field_outer">
                   <label className= "DRM_Form_label">
                     zone
                   </label>
                   <input
                     className= "DRM_Form_text_input"
                     style={{ paddingLeft: "8px" }}
                     name="Zone"
                     value= {formData.Zone}
                     onChange= {handleInputChange}
                     disabled= {disable}
                     maxLength={256}
                   />
                   {errors.Zone && <p className={styles.MarketVisitReport__validationErrors}>{errors.Zone}</p>}
                </div> */}
          {/* <div className="input_field_outer">
          <label className="DRM_Form_label">
            Cluster Name
            
          </label>
          <input
            className="DRM_Form_text_input"
            style={{ paddingLeft: "8px" }}
            name="ClusterName"
            value={formData.ClusterName}
            onChange={handleInputChange}
            disabled={true}
            maxLength={256}
          />
          {errors.ClusterName && <p className={styles.MarketVisitReport__validationErrors}>{errors.ClusterName}</p>}
        </div> */}

          <div className="input_field_outer">
            <label className="DRM_Form_label">Town Name</label>
            <Autocomplete
              id="grouped-demo"
              className="drm__categorySelect"
              options={
                isTownNameData === "Loading"
                  ? [
                      {
                        Town__c: "Loading...",
                      },
                    ]
                  : isTownNameData === "false"
                    ? [
                        {
                          Town__c: "No Data",
                        },
                      ]
                    : !_.isEmpty(townNameOptions)
                      ? townNameOptions
                      : []
              }
              getOptionLabel={(option) => {
                if (option?.Town__c) {
                  return `${option?.Town__c} : ${option.TownCode__c}`;
                } else {
                  return "";
                }
              }}
              disabled={disable || disableTown}
              onChange={(event, newValue) => {
                setSelectedTown(newValue);
                handleAutocompleteChange("TownName", newValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder={
                    townPicklist ? townPicklist : "Select Town Name"
                  }
                />
              )}
            />

            {errors.TownName && (
              <p className={styles.MarketVisitReport__validationErrors}>
                {errors.TownName}
              </p>
            )}
          </div>

          <div className="input_field_outer">
            <label className="DRM_Form_label">Dealer City</label>
            <Autocomplete
              id="dealer-city-autocomplete"
              className="drm__categorySelect"
              options={
                isDealerCityData === "Loading"
                  ? [
                      {
                        DealerCity__c: "Loading...",
                      },
                    ]
                  : isDealerCityData === "false"
                    ? [
                        {
                          DealerCity__c: "No Data",
                        },
                      ]
                    : !_.isEmpty(dealerCityOptions)
                      ? dealerCityOptions
                      : []
              }
              getOptionLabel={(option) => {
                if (option?.DealerCity__c) {
                  return `${option?.DealerCity__c} : ${option.CityCode__c}`;
                } else {
                  return "";
                }
              }}
              disabled={disable}
              onChange={(event, newValue) => {
                setSelectedDealerCity(newValue);
                handleAutocompleteChange("DealerCity", newValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder={
                    formData?.DealerCity
                      ? formData?.DealerCity
                      : "Select Dealer City"
                  }
                />
              )}
            />

            {errors.DealerCity && (
              <p className={styles.MarketVisitReport__validationErrors}>
                {errors.DealerCity}
              </p>
            )}
          </div>

          <div className="input_field_outer">
            <label className="DRM_Form_label">
              Subdivision
              <span style={{ color: "red", fontSize: "1rem" }}>*</span>
            </label>
            <Autocomplete
              id="subdivision-autocomplete"
              disableClearable={true}
              className="drm__categorySelect"
              value={selectedSubdivision}
              options={
                isSubdivisionData === "Loading"
                  ? [
                      {
                        subdivision_name: "Loading...",
                      },
                    ]
                  : isSubdivisionData === "false"
                    ? [
                        {
                          subdivision_name: "No Data",
                        },
                      ]
                    : !_.isEmpty(subdivisionOptions)
                      ? subdivisionOptions
                      : []
              }
              getOptionLabel={(option) => {
                if (option?.subdivision_name) {
                  return `${option?.subdivision_name} : ${option.subdivision_id}`;
                } else {
                  return "";
                }
              }}
              disabled={disable}
              onChange={(e, newValue) => {
                setSelectedSubdivision(newValue);
                setFormData({
                  ...formData,
                  SubdivisionId: newValue?.subdivision_id || "",
                  SubdivisionName: newValue?.subdivision_name || "",
                });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder={
                    formData?.SubdivisionName
                      ? `${formData?.SubdivisionName} : ${formData?.SubdivisionId}`
                      : "Select Subdivision"
                  }
                />
              )}
            />

            {errors.SubdivisionId && (
              <p className={styles.MarketVisitReport__validationErrors}>
                {errors.SubdivisionId}
              </p>
            )}
          </div>

          <div className="input_field_outer">
            <label className="DRM_Form_label">
              TSI Territory Name
              <span style={{ color: "red", fontSize: "1rem" }}>*</span>
            </label>

            <Autocomplete
              id="grouped-demo"
              className="drm__categorySelect"
              isTerritoryData
              options={
                isTerritoryData === "Loading"
                  ? [
                      {
                        TSI_Territory_Name__c: "Loading...",
                        TSI_Territory_Code__c: "",
                      },
                    ]
                  : isTerritoryData === "false"
                    ? [
                        {
                          TSI_Territory_Name__c: "No Data",
                          TSI_Territory_Code__c: "",
                        },
                      ]
                    : getUniqueListBy(
                        territoryDropOption,
                        "TSI_Territory_Code__c",
                      ) || []
              }
              getOptionLabel={(option) => {
                if (option?.TSI_Territory_Name__c) {
                  return `${option?.TSI_Territory_Name__c} ${
                    option?.TSI_Territory_Code__c && ":"
                  } ${option?.TSI_Territory_Code__c}`;
                } else {
                  return "";
                }
              }}
              value={selectedTerritory}
              // value={territoryPickList}

              disabled={disable || disableTown}
              // name="dealerId"
              onChange={(event, newValue) => {
                setSelectedTerritory(newValue);
                handleAutocompleteChange("TSITerritoryName", newValue || "");
                setWssOption([]);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder={
                    territoryPickList ? territoryPickList : "select territory"
                  }
                />
              )}
            />

            {errors.TSITerritoryName && (
              <p className={styles.MarketVisitReport__validationErrors}>
                {errors.TSITerritoryName}
              </p>
            )}
          </div>
          <div className="input_field_outer">
            <label className="DRM_Form_label">
              Customer Code(WSS Code)
              <span style={{ color: "red", fontSize: "1rem" }}>*</span>
            </label>

            <Autocomplete
              multiple
              id="grouped-demo"
              className="drm__categorySelect"
              options={
                isWssData === "Loading"
                  ? [
                      {
                        CustomerName__c: "Loading...",
                        Customer_Code__c: "",
                      },
                    ]
                  : isWssData === "false"
                    ? [
                        {
                          CustomerName__c: "No Data",
                          Customer_Code__c: "",
                        },
                      ]
                    : getUniqueListBy(wssOption, "CustomerName__c") || []
              }
              getOptionLabel={(option) => {
                if (option?.CustomerName__c) {
                  return `${option?.CustomerName__c} ${
                    option?.Customer_Code__c && ":"
                  } ${option?.Customer_Code__c}`;
                } else {
                  return "";
                }
              }}
              value={selectedOptions}
              disabled={disable || disableTown}
              onChange={(event, newValue) => {
                setSelectedOptions(newValue);
                handleAutocompleteChange("CustomerName", newValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder={wsspicklist ? wsspicklist : "Select Wss Name"}
                />
              )}
            />

            {errors.CustomerName && (
              <p className={styles.MarketVisitReport__validationErrors}>
                {errors.CustomerName}
              </p>
            )}
          </div>
          {/* <div className="input_field_outer">
          <label className="DRM_Form_label">
            Customer Code(WSS Code) 
            <span style={{ color: "red", fontSize: "1rem" }}>*</span>
          </label>
          <Autocomplete
            multiple
            id="grouped-demo2"
            className="drm__categorySelect"
            options={
              isWssData === "Loading"
                ? [
                  {
                    CustomerName__c: "Loading...",
                    Customer_Code__c: "",
                  },
                ]
                : isWssData === "false" ? [
                  {
                    CustomerName__c: "No Data",
                    Customer_Code__c: "",
                  },
                ] : wssOption
            }
            getOptionLabel={(option) => {
              if (option?.CustomerName__c) {
                return `${option?.CustomerName__c} ${option?.Customer_Code__c && ":"
                  } ${option?.Customer_Code__c}`;
              } else {
                return "";
              }
            }}
            name="subCategory"
          
            disabled={disable}
            onChange={(event, newValue) => {
              setSelectedOptions(newValue);
            }}
            renderInput={(params) => (
              <TextField {...params} placeholder= {wsspicklist ? wsspicklist : "Select Wss Name"} />
            )}
          />
          {errors.CustomerCode && <p className={styles.MarketVisitReport__validationErrors}>{errors.CustomerCode}</p>}
        </div> */}

          {/* <div className="input_field_outer">
          <label className="DRM_Form_label">
            Customer Code(WSS Code) 
            <span style={{ color: "red", fontSize: "1rem" }}>*</span>
          </label>
          <Autocomplete
           
            id="grouped-demo2"
            className="drm__categorySelect"
            options={
              isWssData === "Loading"
                ? [
                  {
                    CustomerName__c: "Loading...",
                    Customer_Code__c: "",
                  },
                ]
                : isWssData === "false" ? [
                  {
                    CustomerName__c: "No Data",
                    Customer_Code__c: "",
                  },
                ] : wssOption
            }
            getOptionLabel={(option) => {
              if (option?.CustomerName__c) {
                return `${option?.CustomerName__c} ${option?.Customer_Code__c && ":"
                  } ${option?.Customer_Code__c}`;
              } else {
                return "";
              }
            }}
            name="subCategory"
            value={selectedWss}
            disabled={disable}
            onChange={(event, newValue) => {
              // setSelectLatLong(newValue);
              setSelectedWss(newValue)
              handleAutocompleteChange("CustomerCode",newValue)
            }}
            renderInput={(params) => (
              <TextField {...params} placeholder= {wsspicklist ? wsspicklist : "Select Wss Name"} />
            )}
          />
          {errors.CustomerCode && <p className={styles.MarketVisitReport__validationErrors}>{errors.CustomerCode}</p>}
        </div> */}

          {/* <div className="input_field_outer">
          <label className="DRM_Form_label">
            Town Code
            <span style={{ color: "red", fontSize: "1rem" }}>*</span>
          </label>
          <input
            className="DRM_Form_text_input"
            style={{ paddingLeft: "8px" }}
            name="TownCode"
            value={formData.TownCode}
            onChange={handleInputChange}
            disabled={disable}
            maxLength={256}
          />
          {errors.TownCode && <p className={styles.MarketVisitReport__validationErrors}>{errors.TownCode}</p>}
        </div> */}
          {/* <div className="input_field_outer">
          <label className="DRM_Form_label">
            Customer Name
          </label>
          <input
            className="DRM_Form_text_input"
            style={{ paddingLeft: "8px" }}
            name="CustomerName"
            value={formData.CustomerName}
            onChange={handleInputChange}
            disabled={disable}
            maxLength={256}
          />
          {errors.CustomerName && <p className={styles.MarketVisitReport__validationErrors}>{errors.CustomerName}</p>}
        </div> */}
          {/* <div className="input_field_outer Free_input">
          <label className="DRM_Form_label">
            Population (in lacs)

          </label>
          <input
            className="DRM_Form_text_input"
            style={{ paddingLeft: "8px" }}
            type="number"
            name="Population"
            value={formData.Population}
            onChange={handleInputChange}
            disabled={disable}
            maxLength={256}
          />
          {errors.Population && <p className={styles.MarketVisitReport__validationErrors}>{errors.Population}</p>}
        </div> */}
          {/* <div  className="input_field_outer">
                   <label className= "DRM_Form_label">
                     Type of Competition Market
                   </label>
                   <div className="DRM_Multiselect_Wrapper">
                     <Autocomplete
                     className="drm__categorySelect"
                     options={options}
                     disabled= {disable}
                     style={{ width: '100%' }}
                     renderInput={(params) => (
                        <TextField {...params} placeholder={""} />
                      )}
                    value={formData.TypeOfCompetitionMarket}
                     onChange={(event, newValue) => handleAutocompleteChange("TypeOfCompetitionMarket",newValue)}
                     />
                   </div>
                   {errors.TypeOfCompetitionMarket && <p className={styles.MarketVisitReport__validationErrors}>{errors.TypeOfCompetitionMarket}</p>}
                </div> */}
          {/* <div className="input_field_outer">
          <label className="DRM_Form_label">
            Quarter (Q1/Q2/Q3/Q4)
            <span style={{ color: "red", fontSize: "1rem" }}>*</span>
          </label>
          <div className="DRM_Multiselect_Wrapper">
            <Autocomplete
            
              className="drm__categorySelect"
              options={Quarter}
              disabled={disable}
              style={{ width: '100%' }}
              renderInput={(params) => (
                <TextField {...params} placeholder={""} />
              )}
              value={formData.Quarter}
              onChange={(event, newValue) => handleAutocompleteChange("Quarter", newValue)}
            />
          </div>
          {errors.Quarter && <p className={styles.MarketVisitReport__validationErrors}>{errors.Quarter}</p>}
        </div> */}
          <div className="input_field_outer">
            <label className="DRM_Form_label">
              Objective of Meet
              <span style={{ color: "red", fontSize: "1rem" }}>*</span>
            </label>
            <div className="DRM_Multiselect_Wrapper">
              <Autocomplete
                className="drm__categorySelect"
                options={withSelectedOption(
                  dealerRelationshipMeeet?.Objective_of_meet__c,
                  formData.ObjectiveOfMeet
                )}
                disabled={disable}
                style={{ width: "100%" }}
                filterSelectedOptions
                filterOptions={(options, { inputValue }) =>
                  options.filter((option) =>
                    option?.toLowerCase().includes(inputValue.toLowerCase())
                  )
                }
                renderInput={(params) => (
                  <TextField {...params} placeholder={""} />
                )}
                value={formData.ObjectiveOfMeet}
                onChange={(event, newValue) =>
                  handleAutocompleteChange("ObjectiveOfMeet", newValue)
                }
              />
            </div>
            {errors.ObjectiveOfMeet && (
              <p className={styles.MarketVisitReport__validationErrors}>
                {errors.ObjectiveOfMeet}
              </p>
            )}
          </div>
          <div className="input_field_outer">
            <label className="DRM_Form_label">
              Type of DRM
              <span style={{ color: "red", fontSize: "1rem" }}>*</span>
            </label>
            <div className="DRM_Multiselect_Wrapper">
              <Autocomplete
                className="drm__categorySelect"
                options={withSelectedOption(
                  dealerRelationshipMeeet?.Type_of_DRM__c,
                  formData.TypeOfDRM
                )}
                disabled={disable}
                style={{ width: "100%" }}
                filterSelectedOptions
                filterOptions={(options, { inputValue }) =>
                  options.filter((option) =>
                    option?.toLowerCase().includes(inputValue.toLowerCase())
                  )
                }
                renderInput={(params) => (
                  <TextField {...params} placeholder={""} />
                )}
                value={formData.TypeOfDRM}
                onChange={(event, newValue) =>
                  handleAutocompleteChange("TypeOfDRM", newValue)
                }
              />
            </div>
            {errors.TypeOfDRM && (
              <p className={styles.MarketVisitReport__validationErrors}>
                {errors.TypeOfDRM}
              </p>
            )}
          </div>
          {/* <div className="input_field_outer">
          <label className="DRM_Form_label">
            Planned DRM Type
            <span style={{ color: "red", fontSize: "1rem" }}>*</span>
          </label>

          <div className="DRM_Multiselect_Wrapper">
            <Autocomplete
              className="drm__categorySelect"
              options={dealerRelationshipMeeet?.Planned_DRM_Type__c}
              disabled={disable}
              style={{ width: "100%" }}
              renderInput={(params) => <TextField {...params} placeholder="" />}
              value={formData.PlannedDRMType}
              onChange={(event, newValue) =>
                handleAutocompleteChange("PlannedDRMType", newValue)
              }
            />
          </div>

          {errors.PlannedDRMType && (
            <p className={styles.MarketVisitReport__validationErrors}>
              {errors.PlannedDRMType}
            </p>
          )}
        </div> */}

          {userType === "TMM" && (
            <div className="input_field_outer">
              <label className="DRM_Form_label">
                Planned DRM Type
                <span style={{ color: "red", fontSize: "1rem" }}>*</span>
              </label>

              <div className="DRM_Multiselect_Wrapper">
                <Autocomplete
                  className="drm__categorySelect"
                  options={withSelectedOption(
                    dealerRelationshipMeeet?.Planned_DRM_Type__c,
                    formData.PlannedDRMType
                  )}
                  disabled={disable}
                  style={{ width: "100%" }}
                  filterSelectedOptions
                  filterOptions={(options, { inputValue }) =>
                    options.filter((option) =>
                      option?.toLowerCase().includes(inputValue.toLowerCase())
                    )
                  }
                  renderInput={(params) => (
                    <TextField {...params} placeholder="" />
                  )}
                  value={formData.PlannedDRMType}
                  onChange={(event, newValue) =>
                    handleAutocompleteChange("PlannedDRMType", newValue)
                  }
                />
              </div>

              {errors.PlannedDRMType && (
                <p className={styles.MarketVisitReport__validationErrors}>
                  {errors.PlannedDRMType}
                </p>
              )}
            </div>
          )}

          <div className="input_field_outer">
            <label className="DRM_Form_label">
              Town Selection Criteria
              <span style={{ color: "red", fontSize: "1rem" }}>*</span>
            </label>
            <div className="DRM_Multiselect_Wrapper">
              <Autocomplete
                className="drm__categorySelect"
                options={withSelectedOption(
                  dealerRelationshipMeeet?.Town_Selection_criteria__c,
                  formData.TownSelectionCriteria
                )}
                disabled={disable}
                style={{ width: "100%" }}
                filterSelectedOptions
                filterOptions={(options, { inputValue }) =>
                  options.filter((option) =>
                    option?.toLowerCase().includes(inputValue.toLowerCase())
                  )
                }
                renderInput={(params) => (
                  <TextField {...params} placeholder={""} />
                )}
                value={formData.TownSelectionCriteria}
                onChange={(event, newValue) =>
                  handleAutocompleteChange("TownSelectionCriteria", newValue)
                }
              />
            </div>
            {errors.TownSelectionCriteria && (
              <p className={styles.MarketVisitReport__validationErrors}>
                {errors.TownSelectionCriteria}
              </p>
            )}
          </div>
          <div className="input_field_outer">
            <label className="DRM_Form_label">
              Dealer Selection Criteria
              <span style={{ color: "red", fontSize: "1rem" }}>*</span>
            </label>
            <div className="DRM_Multiselect_Wrapper">
              <Autocomplete
                className="drm__categorySelect"
                options={withSelectedOption(
                  dealerRelationshipMeeet?.Dealer_Selection_Criteria__c,
                  formData.DealerSelectionCriteria
                )}
                disabled={disable}
                style={{ width: "100%" }}
                filterSelectedOptions
                filterOptions={(options, { inputValue }) =>
                  options.filter((option) =>
                    option?.toLowerCase().includes(inputValue.toLowerCase())
                  )
                }
                renderInput={(params) => (
                  <TextField {...params} placeholder={""} />
                )}
                value={formData.DealerSelectionCriteria}
                onChange={(event, newValue) =>
                  handleAutocompleteChange("DealerSelectionCriteria", newValue)
                }
              />
            </div>
            {errors.DealerSelectionCriteria && (
              <p className={styles.MarketVisitReport__validationErrors}>
                {errors.DealerSelectionCriteria}
              </p>
            )}
          </div>
          <div className="input_field_outer">
            <label className="DRM_Form_label">
              If category specific dealers,then which category
            </label>
            <div className="DRM_Multiselect_Wrapper">
              <Autocomplete
                className="drm__categorySelect"
                options={withSelectedOption(
                  dealerRelationshipMeeet?.If_Category_Specific_dealers_then_which__c,
                  formData.IfCategorySpecificDealersThenWhichCategory
                )}
                disabled={disable}
                style={{ width: "100%" }}
                filterSelectedOptions
                filterOptions={(options, { inputValue }) =>
                  options.filter((option) =>
                    option?.toLowerCase().includes(inputValue.toLowerCase())
                  )
                }
                renderInput={(params) => (
                  <TextField {...params} placeholder={""} />
                )}
                value={formData.IfCategorySpecificDealersThenWhichCategory}
                onChange={(event, newValue) =>
                  handleAutocompleteChange(
                    "IfCategorySpecificDealersThenWhichCategory",
                    newValue,
                  )
                }
              />
            </div>
            {errors.IfCategorySpecificDealersThenWhichCategory && (
              <p className={styles.MarketVisitReport__validationErrors}>
                {errors.IfCategorySpecificDealersThenWhichCategory}
              </p>
            )}
          </div>
          {/* <div className="input_field_outer Free_input">
          <label className="DRM_Form_label">
            No. of PCC dealers in town
            <span style={{ color: "red", fontSize: "1rem" }}>*</span>
          </label>
          <input
            className="DRM_Form_text_input"
            type="number"
            style={{ paddingLeft: "8px" }}
            name="NoOfPCCdealersInTown"
            value={formData.NoOfPCCdealersInTown}
            onChange={handleInputChange}
            disabled={disable}
            maxLength={256}
          />
          {errors.NoOfPCCdealersInTown && <p className={styles.MarketVisitReport__validationErrors}>{errors.NoOfPCCdealersInTown}</p>}
        </div> */}

          <div className="excel-upload-wrapper">
            <label className="DRM_Form_label">Upload Dealer List (Excel)</label>

            <div
              className="excel-upload-row"
              style={{
                height: "1.7rem",
                display: "flex",
                alignItems: "center",
                padding: "0 0.75rem",
                border: "1px solid #808080",
                borderRadius: "0.3rem",
                background: "#fff",
                marginBottom: "0.4rem",
              }}
            >
              {/* FILE NAME */}
              <div
                className="file-name"
                style={{
                  fontSize: "0.75rem",
                  color: "#444",
                  width: "70%",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                }}
              >
                {excelFileName ? excelFileName : "No file selected"}
              </div>

              {/* UPLOAD BUTTON (when NO file exists) */}
              {!excelFileName && (
                <label
                  className="excel-upload-btn"
                  style={{
                    color: "#2cc26a",
                    fontSize: "0.8rem",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    background: "none",
                    padding: "0",
                  }}
                >
                  <MdOutlineAttachment
                    style={{
                      height: "1.2em",
                      width: "1.2em",
                      color: "#2cc26a",
                    }}
                  />
                  Upload
                  <input
                    type="file"
                    accept=".xlsx,.xls"
                    onChange={handleExcelUpload}
                    style={{ display: "none" }}
                  />
                </label>
              )}

              {/* DOWNLOAD BUTTON (when file exists) */}
              {excelFileName && uploadedFile.base64 && (
                <div
                  style={{ display: "flex", gap: "12px", alignItems: "center" }}
                >
                  <button
                    onClick={() => {
                      const cleanBase64 = uploadedFile.base64.replace(
                        /^data:.*;base64,/,
                        "",
                      );

                      const mimeType = excelFileName.endsWith(".xlsx")
                        ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        : "application/vnd.ms-excel";

                      const blob = base64ToBlob(cleanBase64, mimeType);
                      const url = URL.createObjectURL(blob);

                      const link = document.createElement("a");
                      link.href = url;
                      link.download = excelFileName;
                      link.click();

                      URL.revokeObjectURL(url);
                    }}
                    style={{
                      color: "#2cc26a",
                      fontSize: "0.8rem",
                      cursor: "pointer",
                      background: "none",
                      border: "none",
                      padding: "0",
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    <MdOutlineAttachment
                      style={{
                        height: "1.2em",
                        width: "1.2em",
                        color: "#2cc26a",
                      }}
                    />
                    Download
                  </button>
                  <button
                    onClick={() => {
                      setExcelFileName("");
                      setUploadedFile({
                        fileName: "",
                        base64: "",
                        fileExtension: "",
                        totalDealers: 0,
                        totalParticipants: 0,
                        dealerCode: "",
                      });
                    }}
                    style={{
                      color: "#dc3545",
                      fontSize: "0.8rem",
                      cursor: "pointer",
                      background: "none",
                      border: "none",
                      padding: "0",
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    <MdDeleteOutline
                      style={{
                        height: "1.2em",
                        width: "1.2em",
                        color: "#dc3545",
                      }}
                    />
                    Remove
                  </button>
                </div>
              )}
            </div>

            {/* File format text */}
            <div
              className="file-format-info"
              style={{
                marginTop: "0.2rem",
                marginBottom: "0.8rem",
                fontSize: "0.72rem",
                color: "#777",
              }}
            >
              (format: xlsx, xls — max size 5MB)
            </div>

            {drmTemplateUrl && (
              <div style={{ marginTop: "0.2rem", marginBottom: "0.4rem" }}>
                <a
                  href={drmTemplateUrl}
                  download={TEMPLATE_NAMES.DRM_DEALER_LIST}
                  style={{ fontSize: "0.72rem", color: "#2cc26a", textDecoration: "underline" }}
                >
                  Download Sample Format
                </a>
              </div>
            )}

            {excelValidation && (
              <p className="excel-error" style={{ marginTop: "-0.5rem" }}>
                {excelValidation}
              </p>
            )}
          </div>

          <div className="input_field_outer Free_input">
            <label className="DRM_Form_label">
              Estimated no of dealers to participate
              <span style={{ color: "red", fontSize: "1rem" }}>*</span>
            </label>
            <input
              className="DRM_Form_text_input"
              type="number"
              style={{ paddingLeft: "8px" }}
              name="EstimatedNoOfDealersToParticipate"
              value={formData.EstimatedNoOfDealersToParticipate}
              onChange={handleInputChange}
              disabled={disable}
              maxLength={256}
            />
            {errors.EstimatedNoOfDealersToParticipate && (
              <p className={styles.MarketVisitReport__validationErrors}>
                {errors.EstimatedNoOfDealersToParticipate}
              </p>
            )}
          </div>
          <div className="input_field_outer Free_input">
            <label className="DRM_Form_label">
              Dealers Head Count
              <span style={{ color: "red", fontSize: "1rem" }}>*</span>
            </label>
            <input
              className="DRM_Form_text_input"
              type="number"
              style={{ paddingLeft: "8px" }}
              name="TotalHeadCountDealer"
              value={formData.TotalHeadCountDealer}
              onChange={handleInputChange}
              disabled={disable}
              maxLength={256}
            />
            {errors.TotalHeadCountDealer && (
              <p className={styles.MarketVisitReport__validationErrors}>
                {errors.TotalHeadCountDealer}
              </p>
            )}
          </div>
          <div className="input_field_outer Free_input">
            <label className="DRM_Form_label">
              Employees Head Count
              <span style={{ color: "red", fontSize: "1rem" }}>*</span>
            </label>
            <input
              className="DRM_Form_text_input"
              type="number"
              style={{ paddingLeft: "8px" }}
              name="TotalHeadCountEmployee"
              value={formData.TotalHeadCountEmployee}
              onChange={handleInputChange}
              disabled={disable}
              maxLength={256}
            />
            {errors.TotalHeadCountEmployee && (
              <p className={styles.MarketVisitReport__validationErrors}>
                {errors.TotalHeadCountEmployee}
              </p>
            )}
          </div>
          <div className="input_field_outer Free_input">
            <label className="DRM_Form_label">
              Cost Per Head
              <span style={{ color: "red", fontSize: "1rem" }}>*</span>
            </label>
            <input
              className="DRM_Form_text_input"
              type="number"
              style={{ paddingLeft: "8px" }}
              name="CostPerHead"
              value={formData.CostPerHead}
              onChange={handleInputChange}
              disabled={disable}
              maxLength={256}
            />
            {errors.CostPerHead && (
              <p className={styles.MarketVisitReport__validationErrors}>
                {errors.CostPerHead}
              </p>
            )}
          </div>
          {showReason && (
            <>
              <div className="input_field_outer Free_input">
                <label className="DRM_Form_label">
                  Reason for Deviation
                  <span style={{ color: "red", fontSize: "1rem" }}>*</span>
                </label>
                <textarea
                  className="DRM_Form_text_input"
                  style={{ paddingLeft: "8px", height: "3rem" }}
                  name="DeviationComments"
                  value={formData.DeviationComments || ""}
                  onChange={handleInputChange}
                  disabled={disable}
                  maxLength={256}
                  placeholder="Explain why Cost Per Head exceeds the maximum allowed"
                />
                {errors.DeviationComments && (
                  <p className={styles.MarketVisitReport__validationErrors}>
                    {errors.DeviationComments}
                  </p>
                )}
              </div>
            </>
          )}

          <div className="input_field_outer Free_input">
            <label className="DRM_Form_label">Total Cost (Read only)</label>
            <input
              className="DRM_Form_text_input"
              type="number"
              style={{ paddingLeft: "8px" }}
              name="TotalCost"
              value={formData.TotalCost}
              onChange={handleInputChange}
              disabled={true}
              maxLength={256}
            />
            {errors.TotalCost && (
              <p className={styles.MarketVisitReport__validationErrors}>
                {errors.TotalCost}
              </p>
            )}
          </div>
          {/* <div className="input_field_outer Free_input">
          <label className="DRM_Form_label">
            Current Monthly Average Sales Of Town
            <span style={{ color: "red", fontSize: "1rem" }}>*</span>
          </label>
          <input
            className="DRM_Form_text_input"
            type="number"
            style={{ paddingLeft: "8px" }}
            name="CurrentMonthlyAverageSalesOfTown"
            value={formData.CurrentMonthlyAverageSalesOfTown}
            onChange={handleInputChange}
            disabled={disable}
            maxLength={256}
          />
          {errors.CurrentMonthlyAverageSalesOfTown && <p className={styles.MarketVisitReport__validationErrors}>{errors.CurrentMonthlyAverageSalesOfTown}</p>}
        </div> */}
          {/* <div className="input_field_outer Free_input">
          <label className="DRM_Form_label">
            Post DRM Monthly Average Sale Planned For The Town
            <span style={{ color: "red", fontSize: "1rem" }}>*</span>
          </label>
          <input
            className="DRM_Form_text_input"
            type="number"
            style={{ paddingLeft: "8px" }}
            name="PostDRMMonthlyAverageSalePlannedForTheTown"
            value={formData.PostDRMMonthlyAverageSalePlannedForTheTown}
            onChange={handleInputChange}
            disabled={disable}
            maxLength={256}
          />
          {errors.PostDRMMonthlyAverageSalePlannedForTheTown && <p className={styles.MarketVisitReport__validationErrors}>{errors.PostDRMMonthlyAverageSalePlannedForTheTown}</p>}
        </div> */}

          <div>
            <label className={styles.MarketVisitReport__selectLabel}>
              Tentative date of the meet
              <span style={{ color: "red", fontSize: "1rem" }}>*</span>
            </label>
            <br />
            <Box className="myDatePicker">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  sx={{
                    width: "100%",
                    whiteSpace: "nowrap",
                    height: "1.7rem",
                    marginBottom: "0.8rem",
                    border: "0.692008px solid #808080",
                    borderRadius: "0.3rem",
                    color: "#808080",
                  }}
                  className={styles.MarketVisitReport__dateField}
                  value={formData.TentativeDateOfTheMeet}
                  disabled={disable}
                  minDate={mindate}
                  onChange={(newValue) =>
                    handleDateChange("TentativeDateOfTheMeet", newValue)
                  }
                />
              </LocalizationProvider>
            </Box>
            {errors.TentativeDateOfTheMeet && (
              <p className={styles.MarketVisitReport__validationErrors}>
                {errors.TentativeDateOfTheMeet}
              </p>
            )}
          </div>

          <div>
            <label className={styles.MarketVisitReport__selectLabel}>
              Actual Date of the Meet
            </label>
            <br />
            <Box className="myDatePicker">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  sx={{
                    width: "100%",
                    whiteSpace: "nowrap",
                    height: "1.7rem",
                    marginBottom: "0.8rem",
                    border: "0.692008px solid #808080",
                    borderRadius: "0.3rem",
                    color: "#808080",
                  }}
                  className={styles.MarketVisitReport__dateField}
                  value={formData.ActualDateOfTheMeet ?? null}
                  disabled={disableactualdate}
                  onChange={(newValue) =>
                    handleDateChange("ActualDateOfTheMeet", newValue)
                  }
                />
              </LocalizationProvider>
            </Box>
            {errors.Zone && (
              <p
                className={styles.MarketVisitReport__validationErrors}
              >{`Zone - ${errors.Zone}`}</p>
            )}
            {executiondisable && (
              <>
                <div className={"flex p-2"}>
                  <div className={`${styles.MarketVisitReport__inputWrapper}`}>
                    <MdOutlineAttachment
                      style={{
                        height: "1.5em",
                        width: "1.5em",
                        color: "#2cc26a",
                        marginRight: "5px",
                      }}
                    />
                    Attach File
                    {/* <span style={{ color: "red", fontSize: "1rem" }}>*</span> */}
                    <label className={styles.MarketVisitReport_fileInputLabel}>
                      <input
                        className={`${styles.MarketVisitReport_fileInput}`}
                        type="file"
                        accept=".jpg,.png, .jpeg"
                        multiple
                        onChange={(e) => handleFileChange(e)}
                      />
                    </label>
                  </div>
                  {selectedFiles?.length > 0 && (
                    <div className={styles.MarketVisitReport_selectedFiles}>
                      {selectedFiles?.length === 1
                        ? `File: ${selectedFiles[0].name}`
                        : `Selected Files: ${selectedFiles.length}`}
                    </div>
                  )}

                  {fileValidation && (
                    <p className={styles.MarketVisitReport__validationErrors}>
                      {fileValidation}
                    </p>
                  )}
                </div>
                <div className={"flex p-1"}>
                  <div className="file_instruction">
                    (format: jpeg,png,jpg, max 5 images each below 10mb)
                  </div>
                </div>

                <div className="input_field_outer Free_input">
                  <label className="DRM_Form_label">
                    Actual no. of dealers participated
                    <span style={{ color: "red", fontSize: "1rem" }}>*</span>
                  </label>
                  <input
                    className="DRM_Form_text_input"
                    type="number"
                    style={{ paddingLeft: "8px" }}
                    name="ActualNoOfDealersParticipated"
                    value={formData.ActualNoOfDealersParticipated}
                    onChange={handleInputChange}
                    disabled=""
                    maxLength={256}
                  />
                  {errors.ActualNoOfDealersParticipated && (
                    <p className={styles.MarketVisitReport__validationErrors}>
                      {errors.ActualNoOfDealersParticipated}
                    </p>
                  )}
                </div>
                <div className="input_field_outer Free_input">
                  <label className="DRM_Form_label">
                    Actual no. of employees participated
                    <span style={{ color: "red", fontSize: "1rem" }}>*</span>
                  </label>
                  <input
                    className="DRM_Form_text_input"
                    type="number"
                    style={{ paddingLeft: "8px" }}
                    name="ActualNoOfEmployeesParticipated"
                    value={formData.ActualNoOfEmployeesParticipated}
                    onChange={handleInputChange}
                    disabled=""
                    maxLength={256}
                  />
                  {errors.ActualNoOfEmployeesParticipated && (
                    <p className={styles.MarketVisitReport__validationErrors}>
                      {errors.ActualNoOfEmployeesParticipated}
                    </p>
                  )}
                </div>

                <div className="input_field_outer Free_input">
                  <label className="DRM_Form_label">
                    Actual Cost
                    <span style={{ color: "red", fontSize: "1rem" }}>*</span>
                  </label>
                  <input
                    className="DRM_Form_text_input"
                    type="number"
                    style={{ paddingLeft: "8px" }}
                    name="ActualCost"
                    value={formData.ActualCost}
                    onChange={handleInputChange}
                    disabled=""
                    maxLength={256}
                  />
                  {errors.ActualCost && (
                    <p className={styles.MarketVisitReport__validationErrors}>
                      {errors.ActualCost}
                    </p>
                  )}
                </div>

                <div className="input_field_outer Free_input">
                  <label className="DRM_Form_label">
                    BM Remark
                    <span style={{ color: "red", fontSize: "1rem" }}>*</span>
                  </label>
                  <textarea
                    className="DRM_Form_text_input"
                    style={{ paddingLeft: "8px", height: "3rem" }}
                    name="BMRemark"
                    value={formData.BMRemark}
                    onChange={handleInputChange}
                    disabled=""
                    maxLength={256}
                  />
                  {errors.BMRemark && (
                    <p className={styles.MarketVisitReport__validationErrors}>
                      {errors.BMRemark}
                    </p>
                  )}
                </div>
              </>
            )}
          </div>
          {startExecution ? (
            <button
              type="button"
              className="btn mt-3"
              style={{
                padding: "0",
                width: "100%",
                backgroundColor: "#3901FF",
                color: "white",
                fontSize: "13px",
                height: "1.8rem",
              }}
              disabled={DisableSubmitDRM}
              onClick={() => handleSpecaSubmit()}
            >
              Submit DRM <FiArrowRight style={{ marginLeft: "2px" }} />
            </button>
          ) : unableupdate ? (
            <button
              type="submit"
              className="btn mt-3 drm__createMeetingButton"
              disabled={disable}
            >
              Create Meeting <FiArrowRight style={{ marginLeft: "2px" }} />
            </button>
          ) : (
            <button
              type="button"
              className="btn mt-3 drm__updateButton"
              disabled={disableUpdate}
              onClick={() => handleUpdate()}
            >
              Update <FiArrowRight style={{ marginLeft: "2px" }} />
            </button>
          )}

          {isSubmitModalOpen && (
            <ModalPopup
              className="ModalPopup_Submitted"
              isModalOpen={isSubmitModalOpen}
              setIsModalOpen={setIsSubmitModalOpen}
              title="Submitted Successfully"
              data="Your DRM meeting has been created successfully."
              backdrop={true}
              fade={false}
              icon={
                <>
                  <div className="submittedIcons draftIcons">
                    <FaThumbsUp className="submittedSmall" />
                    <FaThumbsUp className="submittedLarge" />
                    <FaThumbsUp className="submittedSmall" />
                  </div>
                </>
              }
            />
          )}
          {isUpdateModalOpen && (
            <ModalPopup
              className="ModalPopup_Submitted"
              isModalOpen={isUpdateModalOpen}
              setIsModalOpen={setIsUpdateModalOpen}
              title="Updated Successfully"
              data="Your DRM form has been updated successfully."
              backdrop={true}
              fade={false}
              icon={
                <>
                  <div className="submittedIcons draftIcons">
                    <FaThumbsUp className="submittedSmall" />
                    <FaThumbsUp className="submittedLarge" />
                    <FaThumbsUp className="submittedSmall" />
                  </div>
                </>
              }
            />
          )}

          {specamodal && (
            <ModalPopup
              className="ModalPopup_Submitted"
              isModalOpen={specamodal}
              setIsModalOpen={setSpecaModal}
              title="Submitted Successfully"
              data="Your DRM form has been submitted successfully to SPECA."
              backdrop={true}
              fade={false}
              icon={
                <>
                  <div className="submittedIcons draftIcons">
                    <FaThumbsUp className="submittedSmall" />
                    <FaThumbsUp className="submittedLarge" />
                    <FaThumbsUp className="submittedSmall" />
                  </div>
                </>
              }
            />
          )}
        </form>
      </div>
    </div>
  );
};

export default DRMPlanOne;
